/**
 * @Author: Lzp <liuzp@xinlongmail.com>
 * @Date: 2021-09-29 14:27:21
 * @LastEditors: Lzp
 * @LastEditTime: 2021-09-29 14:27:21
 */

import * as request from '@/utils/request'
const BASE_URL = 'paihuo/hr'
export default {
  /**
   * getPaihuoHumanResourcesList
   * @description 查看列表
   * @author Lzp
   * @date 2021/9/29
   * @param {*} data
   * @returns
   */
  getPaihuoHumanResourcesList(data) {
    return request.get(`${BASE_URL}/list`, data)
  },

  /**
   * viewPaihuoHumanResources
   * @description 详情
   * @author Lzp
   * @date 2021/9/29
   * @returns promise
   */
  viewPaihuoHumanResources(data) {
    return request.get(`${BASE_URL}/view/${data}`)
  },
  
  /**
   * examinePaihuoHumansources
   * @description 审核
   * @author Lzp
   * @date 2021/9/29
   * @param {*} data
   * @returns
   */
  examinePaihuoHumansources(id, data) {
    return request.put(`${BASE_URL}/update/${id}`, data)
  }
}